/*
 HotelTest

 Tresc regulaminu dla hotel-TEST
  
 historia: 
  PM 2021-12-08 - start
*/

import * as React from 'react';

import { withStyles, WithStyles } from '@material-ui/core/styles';
import { Button, Theme, Typography } from '@material-ui/core';

class HotelTest extends React.Component<WithStyles<typeof styles>, any> {

    render() {
        const { classes } = this.props;
        if (document.title !== 'Warunki wynajmu') {
            document.title = 'Warunki wynajmu';
        }

        return (
            <React.Fragment>
                <Typography variant='h6' align="center"><b>WARUNKI REZERWACJI I WYNAJMU DOMKÓW</b></Typography>
                <Typography variant='h6' align="center"><b>Ośrodek Szkoleniowo-Wypoczynkowy PCK w Sławie</b></Typography>
                <br />
                
                <Typography variant='h6' align="center" style={{fontSize: "16px"}} ><b>§1. Postanowienia ogólne</b></Typography>
                <ol type="1">
                    <li><Typography variant='body2' gutterBottom>Niniejsze Warunki Rezerwacji i Wynajmu określają zasady dokonywania rezerwacji oraz korzystania z domków znajdujących się na terenie Ośrodka Szkoleniowo-Wypoczynkowego PCK w Sławie.</Typography></li>
                    <li><Typography variant='body2' gutterBottom>Rezerwacje	dokonywane	są	za	pośrednictwem	strony	internetowej <a href="https://www.osrodekpckslawa.pl/" target="_blank" rel="noreferrer" className={classes.link}>
                        <Button
                            variant="text"
                            size="large"
                            className={`${classes.linkButton} ${classes.body2Button}`}
                        >
                            www.osrodekpckslawa.pl
                        </Button>
                    </a> lub telefonicznie pod numerem wskazanym w zakładce „Kontakt”.</Typography></li>  
                </ol>
                <br />
                <hr style={{ border: "0", borderBottom: "1px solid rgb(224, 224, 224)" }} />

                <br />
                <Typography variant='h6' align="center" style={{fontSize: "16px"}} ><b>§2. Dane właściciela obiektu</b></Typography>
                <ol type="1">
                    <li>
                        <Typography variant='body2' gutterBottom>Właścicielem Ośrodka oraz administratorem serwisu internetowego jest:<br/><b>Lubuski Oddział Okręgowy Polskiego Czerwonego Krzyża</b><br/>ul. Jedności 22B; 65-018 Zielona Góra
                            <ul>
                                <li>REGON: 007023731-00487; NIP: 9290113928</li>
                                <li>E-mail: <a href={`mailto:${'zielonagora@pck.pl'}`} target='_blank' className={`${classes.email}`}>{'zielonagora@pck.pl'}</a></li>
                                <li>Numer rachunku bankowego: Bank Millennium S.A. 65 1160 2202 0000 0005 1756 8063</li>
                            </ul>
                        </Typography>
                    </li>
                </ol>
                <br />
                <hr style={{ border: "0", borderBottom: "1px solid rgb(224, 224, 224)" }} />



                <br />
                <Typography variant='h6' align="center" style={{fontSize: "16px"}} ><b>§3. Zasady dokonywania rezerwacji</b></Typography>
                <ol type="1">
                    <li>
                        <Typography variant='body2' gutterBottom>Rezerwacji domku można dokonać:</Typography>
                        <ul>
                            <li>online za pośrednictwem strony internetowej Obiektu,</li>
                            <li>telefonicznie.</li>
                        </ul>
                    </li>
                    <li><Typography variant='body2' gutterBottom>Warunkiem potwierdzenia rezerwacji online jest dokonanie płatności w wysokości 100% wartości pobytu w momencie składania rezerwacji.</Typography></li>
                    <li><Typography variant='body2' gutterBottom>Dopuszcza się możliwość dokonania płatności w Obiekcie przed zakwaterowaniem, od poniedziałku do piątku, po wcześniejszym ustaleniu terminu i godziny przyjazdu z personelem Ośrodka.</Typography></li>  
                    <li><Typography variant='body2' gutterBottom>Operatorem płatności internetowych jest firma <b>PayU.</b></Typography></li>  
                    <li><Typography variant='body2' gutterBottom>W recepcji Ośrodka akceptowane są płatności kartami płatniczymi.</Typography></li>  
                </ol>
                <br />
                <hr style={{ border: "0", borderBottom: "1px solid rgb(224, 224, 224)" }} />


                <br />
                <Typography variant='h6' align="center" style={{fontSize: "16px"}} ><b>§4. Opłata miejscowa</b></Typography>
                <ol type="1">
                    <li><Typography variant='body2' gutterBottom>Opłata miejscowa nie jest wliczona w cenę pobytu i stanowi odrębną należność.</Typography></li>
                    <li><Typography variant='body2' gutterBottom>Opłata pobierana jest w recepcji Ośrodka wyłącznie w formie gotówkowej.</Typography></li>
                    <li><Typography variant='body2' gutterBottom>Wysokość opłaty miejscowej ustalana jest zgodnie z aktualnie obowiązującą uchwałą Rady Miejskiej Gminy Sława.</Typography></li>
                </ol>
                <br />
                <hr style={{ border: "0", borderBottom: "1px solid rgb(224, 224, 224)" }} />


                <br />
                <Typography variant='h6' align="center" style={{fontSize: "16px"}} ><b>§5. Zakwaterowanie i wymeldowanie</b></Typography>
                <ol type="1">
                    <li><Typography variant='body2' gutterBottom>Zakwaterowanie odbywa się po zgłoszeniu się do recepcji oraz podaniu numeru rezerwacji lub nazwiska osoby dokonującej rezerwacji.</Typography></li>
                    <li><Typography variant='body2' gutterBottom>Gość  otrzymuje  klucz  do  domku  po  dopełnieniu  formalności  związanych z zakwaterowaniem.</Typography></li>  
                    <li><Typography variant='body2' gutterBottom>Doba pobytowa rozpoczyna się o godzinie <b>14:00</b> w dniu przyjazdu i kończy o godzinie <b>11:00</b> w dniu wyjazdu.</Typography></li>  
                    <li><Typography variant='body2' gutterBottom>Gość zobowiązany jest zwrócić klucz do domku najpóźniej w chwili wymeldowania.</Typography></li>  
                </ol>
                <br />
                <hr style={{ border: "0", borderBottom: "1px solid rgb(224, 224, 224)" }} />


                <br />
                <Typography variant='h6' align="center" style={{fontSize: "16px"}} ><b>§6. Anulowanie rezerwacji i zwroty</b></Typography>
                <ol type="1">
                    <li><Typography variant='body2' gutterBottom>W przypadku anulowania rezerwacji co najmniej 2 dni przed planowanym terminem przyjazdu, Gościowi przysługuje zwrot wpłaconych środków pomniejszonych o prowizję operatora płatności.</Typography></li>
                    <li><Typography variant='body2' gutterBottom>Osoba rezygnująca z pobytu i ubiegająca się o zwrot wpłaconych środków zobowiązana jest do zgłoszenia anulowania rezerwacji za pośrednictwem wiadomości SMS wysłanej na numer telefonu wskazany w potwierdzeniu rezerwacji. Wiadomość powinna zawierać numer rezerwacji objętej anulowaniem.</Typography></li>
                    <li><Typography variant='body2' gutterBottom>Warunkiem dokonania zwrotu jest przesłanie prawidłowo wypełnionego formularza zwrotu, dostępnego na stronie internetowej Obiektu.</Typography></li>  
                    <li><Typography variant='body2' gutterBottom>Zwrot środków nastąpi na rachunek bankowy wskazany przez Gościa w formularzu, w terminie do 14 dni roboczych od dnia otrzymania prawidłowo wypełnionego formularza.</Typography></li>  
                    <li><Typography variant='body2' gutterBottom>W przypadku anulowania rezerwacji na mniej niż 1 dzień przed planowanym terminem przyjazdu wpłacone środki nie podlegają zwrotowi.</Typography></li>  
                </ol>
                <br />
                <hr style={{ border: "0", borderBottom: "1px solid rgb(224, 224, 224)" }} />

                <br />
                <Typography variant='h6' align="center" style={{fontSize: "16px"}} ><b>§7. Reklamacje</b></Typography>
                <ol type="1">
                    <li><Typography variant='body2' gutterBottom>Wszelkie	reklamacje	należy	zgłaszać	drogą	elektroniczną	na	adres: <a href={`mailto:${'zielonagora@pck.pl'}`} target='_blank' className={`${classes.email}`}>{'zielonagora@pck.pl'}</a>.</Typography></li>
                    <li><Typography variant='body2' gutterBottom>Reklamacje będą rozpatrywane w terminie do 14 dni roboczych od dnia ich otrzymania.</Typography></li>
                    <li><Typography variant='body2' gutterBottom>W przypadku anulowania rezerwacji na mniej niż 1 dzień przed planowanym terminem przyjazdu wpłacone środki nie podlegają zwrotowi.</Typography></li>  
                </ol>
                <br />
                <hr style={{ border: "0", borderBottom: "1px solid rgb(224, 224, 224)" }} />
            

                <br />
                <Typography variant='h6' align="center" style={{ fontSize: "16px" }} ><b>§8. Postanowienia końcowe</b></Typography>
                <ol type="1">
                    <li><Typography variant='body2' gutterBottom>Dokonanie rezerwacji jest równoznaczne z akceptacją niniejszych Warunków Rezerwacji i Wynajmu.</Typography></li>
                    <li><Typography variant='body2' gutterBottom>W sprawach nieuregulowanych niniejszym dokumentem zastosowanie mają przepisy prawa polskiego, w szczególności przepisy Kodeksu cywilnego.</Typography></li>
                </ol>
                <br />
                <hr style={{ border: "0", borderBottom: "1px solid rgb(224, 224, 224)" }} />

            </React.Fragment>
        );
    }
}

const styles = (theme: Theme) => ({
    listItem: {
        display: 'list-item',
        marginLeft: theme.spacing(5),
    },
    listNone: {
        listStyleType: 'none'
    },
    breakSpaces: {
        whiteSpace: 'break-spaces' as 'break-spaces'
    },
    linkButton: {
        color: '#3a87ad',
        "&:hover": {
            textDecoration: "underline"
        }
    },
    h6Button: {
        padding: 0,
        fontSize: theme.typography.h6.fontSize,
        lineHeight: theme.typography.h6.lineHeight,
        letterSpacing: theme.typography.h6.letterSpacing,
        textTransform: 'none' as 'none',
        minWidth: 0,
        "&:hover": {
            background: 'none'
        }
    },
    body2Button: {
        padding: 0,
        fontSize: theme.typography.body2.fontSize,
        lineHeight: '16px',
        letterSpacing: theme.typography.body2.letterSpacing,
        textTransform: 'none' as 'none',
        minWidth: 0,
        "&:hover": {
            background: 'none'
        }
    },
    link: {
        textDecoration: 'none',
        lineBreak: 'anywhere' as 'anywhere'
    },
    alignCenter: {
        display: 'block',
        textAlign: 'center' as 'center'
    },
    bottomLabelFont: {
        fontSize: '16',
    },
    email: {
        //color: "inherit",
        color: '#3a87ad',
        textDecoration: "none",
        "&:hover": {
            textDecoration: "underline"
        }
    },
});

export default withStyles(styles)(HotelTest);
